import { createContext, useState, useReducer } from 'react'
import { getInitialState } from '../util/persistState'
export const GlobalContext = createContext()

const reducer = (permission, newPermission) => {
  return { ...permission, ...newPermission }
}

export const DataProvider = ({ children }) => {
    const [hasNoData, setHasNoData] = useState(false)
    const [data, setData] = useState([])
    const [useGeofence, setuseGeofence] = useState(null)
    const [showMarker, setShowMarkers] = useState(true)
    const [lat, setLat] = useState(49.3093821)
    const [lng, setLng] = useState(-123.0726476)
    const [selectedLoc, setSelectedLoc] = useState("")
    const [locId, setLocId] = useState("")
    const [locType, setLocType] = useState("")
    const [showImages, setShowImages] = useState(false)
    const [showTabs, setShowTabs] = useState(false)
    const [bounds, setBounds] = useState({})
    const [markers, setMarkers] = useState([])
    const [searchOption, setSearchOption] = useState('Places')

    const [featureTableFilter, setFeatureTableFilter] = useState([
        { column: "Feature Name", isShown: true },
        { column: "Feature Description", isShown: true },
        { column: "Status", isShown: true },
    ])
    const [resourceTableFilter, setResourceTableFilter] = useState([
        { column: "Resource Name", isShown: true },
        { column: "Resource Description", isShown: true },
        { column: "Status", isShown: true },
    ])
    const [groupTableFilter, setGroupTableFilter] = useState([
        { column: "Group Name", isShown: true },
        { column: "Group Description", isShown: true },
        { column: "Status", isShown: true },
        { column: "Members", isShown: true },
    ])
    const [userManagementTableFilter, setUserManagementTableFilter] = useState([
        { column: "Name", isShown: true },
        { column: "Email", isShown: true },
        { column: "Status", isShown: true },
        { column: "Last Login", isShown: true },
    ])

    const [approvalStatusRecordTableFilter, setApprovalStatusRecordTableFilter] = useState([
        { column: "Name", isShown: true },
        { column: "Submitted Status", isShown: true },
        { column: "Date", isShown: true },
    ])

    const [activeTab, setActiveTab] = useState('')

    const [permissions, setPermissions] = useReducer(reducer, getInitialState("permissions") || {});

    const [featureCategories, setFeatureCategories] = useState([
        { categoryName: "Location", data: [], isOpen: false },
        { categoryName: "People", data: [], isOpen: false },
        { categoryName: "Service", data: [], isOpen: false },
        { categoryName: "Account", data: [], isOpen: false },
        { categoryName: "Admin", data: [], isOpen: false },
    ])

    const [territory, setTerritory] = useState([{ isOpen: false }])

    const [resourceCategories, setResourceCategories] = useState([
        { categoryName: "Country", data: [], isOpen: false },
        { categoryName: "Province", data: [], isOpen: false },
        { categoryName: "City", data: [], isOpen: false },
        { categoryName: "Businesses", data: [], isOpen: false },
    ])

    const [selectedTabIndexSmartForm, setSelectedTabIndexSmartForm] = useState(0)

    const [selectedIamCreateTab, setSelectedIamCreateTab] = useState('Group')
    const [selectedOptionItem, setSelectedOptionItem] = useState(null)

    const [dataManagementNotificationCount, setDataManagementNotificationCount] = useState(0)

    const [menuLabels, setMenuLabels] = useState([
        {
            label: 'Roles and Permissions',
            options: ['User Management','Group Management', 'Feature Management', 'Resource Management'],
            isOpen: true
        },
        {
            label: 'Data Management',
            options: ['Account', 'Location', 'People/User', 'Service','Skill Sets'],
            isOpen: false
        },
        {
            label: 'Data Set',
            options: [ 'Import', 'Approve/Reject', 'Export'],
            isOpen: false
        },
        {
            label: 'Appearance Configuration',
            options: ['Colors', 'Font Style', 'Icons'],
            isOpen: false
        },
    ])

    // Advanced Search
    const [advancedSearch, setAdvancedSearch] = useState({})

    // Custom Map Marker
    const [mapMarkerSetting, setMapMarkerSetting] = useState({
      entityTypeColors: {},
      industryTypeIcons: {}
    })
    const [mapMarkerUserSetting, setMapMarkerUserSetting] = useState({})

    const [selectedService, setSelectedService] = useState({})

    const [isLoading, setIsLoading] = useState(false)

    const [contact, setContact] = useState({})
    const [address, setAddress] = useState({})

    const [serviceList, setServiceList] = useState([])
    const [servicesCategorizedByServiceType, setServicesCategorizedByServiceType] = useState({})

    const [tabs, setTabs] = useState([
      {custom_name: 'Dashboard', sys_name: 'tab4', isDisabled: true},
      {custom_name: 'Dashboard Data', sys_name: 'tab5', isDisabled: true},
    ])

    //Side Panel
    const [showSidePanel, setShowSidePanel] = useState(true)

    // Global collapse state for MapSearch
    const [collapseIsOpen, setCollapseIsOpen] = useState(true)

    return (
        <GlobalContext.Provider
            value={{
                locdata: [data, setData],
                useGeofencedata: [useGeofence, setuseGeofence],
                showingMarker: [showMarker, setShowMarkers],
                latCoord: [lat, setLat],
                lngCoord: [lng, setLng],
                selectedText: [selectedLoc, setSelectedLoc],
                id: [locId, setLocId],
                type: [locType, setLocType],
                imageSliderState: [showImages, setShowImages],
                showViewTabs: [showTabs, setShowTabs],
                showBounds: [bounds, setBounds],
                featureTableFilterData: [
                    featureTableFilter,
                    setFeatureTableFilter,
                ],
                resourceTableFilterData: [
                    resourceTableFilter,
                    setResourceTableFilter,
                ],
                groupTableFilterData: [groupTableFilter, setGroupTableFilter],
                userManagementTableFilterData: [
                    userManagementTableFilter,
                    setUserManagementTableFilter,
                ],
                activeTabData: [activeTab, setActiveTab],
                permissionsData: [permissions, setPermissions],
                featuresCategoryData: [featureCategories, setFeatureCategories],
                territoryData: [territory, setTerritory],
                resourceCategoriesData: [resourceCategories, setResourceCategories],
                smartFormSideTab: [selectedTabIndexSmartForm, setSelectedTabIndexSmartForm],
                iamCreateSideTab: [selectedIamCreateTab, setSelectedIamCreateTab],
                serviceImportType: [selectedOptionItem, setSelectedOptionItem],
                approvalStatusRecordTable: [approvalStatusRecordTableFilter, setApprovalStatusRecordTableFilter],
                dataManagementNotificationCount: [dataManagementNotificationCount, setDataManagementNotificationCount],
                adminDashboardMenu: [menuLabels, setMenuLabels],
                advancedSearchData : [advancedSearch, setAdvancedSearch],
                markersData: [markers, setMarkers],
                searchOptionData: [searchOption, setSearchOption],
                mapMarkerSettingData: [mapMarkerSetting, setMapMarkerSetting],
                mapMarkerUserSettingData: [mapMarkerUserSetting, setMapMarkerUserSetting],
                selectedServiceData: [selectedService, setSelectedService],
                isLoadingContext: [isLoading, setIsLoading],
                hasNoDataContext: [hasNoData, setHasNoData],
                contactContext: [contact, setContact],
                addressContext: [address, setAddress],
                serviceListContext: [serviceList, setServiceList],
                servicesCategorizedByServiceTypeContext: [servicesCategorizedByServiceType, setServicesCategorizedByServiceType],
                tabsData: [tabs, setTabs],
                sidePanelState: [showSidePanel, setShowSidePanel],
                collapseIsOpenData: [collapseIsOpen, setCollapseIsOpen]
            }}
        >
            {children}
        </GlobalContext.Provider>
    )
}
